import { Injectable } from '@angular/core';
import swal from 'sweetalert2';
import { Alert } from './Alert';

@Injectable()
export class AlertService {

  constructor() { }

  public swalError(title: string, text: string) {
    return swal(title, text, 'error');
  }

  public swalSuccess(title: string, text: string) {
    return swal(title, text, 'success');
  }

  public swalWarning(title: string, text: string) {
    return swal(title, text, 'warning');
  }

  public swal(title: string, text: string) {
    return swal(title, text);
  }

  /**
   * 
   * @param alert 
   */
  public swalLoad(alert: Alert) {

    return swal({
      title: alert.title,
      text: alert.text,
      timer: alert.timer,
      allowOutsideClick: false,
      onOpen: () => {
        swal.showLoading()
      }
    });
  }

  public load(time) {

    return swal({
      title: 'Aguarde...',
      timer: time,
      allowOutsideClick: false,
      onOpen: () => {
        swal.showLoading()
      }
    });
  }

  public loading(title = 'Aguarde...') {
    return swal({
      title: title,
      allowOutsideClick: false,
      showConfirmButton: false,
      onOpen: () => {
        swal.showLoading()
      }
    });
  }

  public swalConfirm(title: string, text: string, type: any, txtConfirm: string, callback) {
    return swal({
      title: title,
      text: text,
      type: type,
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: txtConfirm
    }).then((result) => {
      if (result.value) {
        callback();
      }
    });
  }

  public swalConfirmCancel(title: string, text: string, type: any, txtConfirm: string, callback, cancel) {
    return swal({
      title: title,
      text: text,
      type: type,
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: txtConfirm,
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.value) {
        callback();
      }
      else {
        cancel();
      }
    });
  }

  public swalConfirmCancelBtnText(title: string, text: string, type: any, txtConfirm: string, txtCancel: string, callback, cancel) {
    return swal({
      title: title,
      text: text,
      type: type,
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: txtConfirm,
      cancelButtonText: txtCancel,
    }).then((result) => {
      if (result.value) {
        callback();
      }
      else {
        cancel();
      }
    });
  }

  public close() {
    swal.close();
  }

}


// WEBPACK FOOTER //
// /var/www/minha-at3-cliente/src/app/alert/alert.service.ts